export default __webpack_public_path__ + "static/media/audisoft3.52e4bd8c.mov";